export type FacebookCustomAudienceOperator = keyof FacebookCustomAudienceRules;

export interface FacebookCustomAudienceRule {
  inclusions: {
    operator: FacebookCustomAudienceOperator | 'and' | 'or';
    rules: FacebookCustomAudienceRuleSet[];
  };
}

export interface FacebookCustomAudienceRuleSet {
  event_sources?: FacebookCustomAudienceEventSource[];
  filter?: FacebookCustomAudienceFilter;
  retention_seconds?: number;
  template?: string;
}

export interface FacebookCustomAudienceSubFilter {
  field: string;
  operator: FacebookCustomAudienceOperator;
  value: FacebookCustomAudienceRules[FacebookCustomAudienceOperator];
}

export interface FacebookCustomAudienceEventSource {
  id: string;
  type: FacebookCustomAudienceEventSourceType;
  owner_id?: string;
}

export enum FacebookCustomAudienceEventSourceType {
  // FB Pixel ID
  PIXEL = 'pixel',
  // FB Page ID
  PAGE = 'page',
  // FB Lead Form ID
  LEAD = 'lead',
  // FB Lead Form ID
  IG_LEAD_GENERATION = 'ig_lead_generation',
  // idk
  CANVAS = 'canvas',
  // IG Business Profile ID
  IG_BUSINESS = 'ig_business',
  // FB Shop Page ID
  SHOPPING_PAG = 'shopping_page',
  // IG Shop ID
  SHOPPING_IG = 'shopping_ig',
}

export interface FacebookCustomAudienceFilter {
  operator: FacebookCustomAudienceOperator;
  filters: FacebookCustomAudienceSubFilter[];
}

export interface FacebookCustomAudienceRules {
  and?: string;
  or?: string;
  i_contains?: string; // Contains case insensitive substring
  i_not_contains?: string; //Does not contain case insensitive substring
  contains?: string; // Contains case sensitive substring
  not_contains?: string; // Does not contain case sensitive substring
  eq?: string; // Equals case sensitive
  neq?: string; // Not equal case sensitive
  lt?: number; // Less than
  ltq?: number; // Less than or equal to
  gt?: number; // Greater than
  gte?: number; // Greater than or equal to
  regex_match?: RegExp; // Matches a regular expression (Full PCRE grammar supported)
}
